import {
  BACKORDER_SUBSCRIBE,
  BACKORDER_SUBSCRIBE_FULFILLED,
  BACKORDER_SUBSCRIBE_REJECTED,
  CLEAR_BACKORDER_SUBSCRIBE,
} from './actionTypes';
import {
  BackorderSubscribeAction,
  BackorderSubscribeFulfilledAction,
  BackorderSubscribeRejectedAction,
  ClearBackorderSubscribeAction,
} from './types';

const clearBackorderSubscribe = (): ClearBackorderSubscribeAction => ({
  type: CLEAR_BACKORDER_SUBSCRIBE,
});

const backorderSubscribe = (email: string, isSubscribed: boolean): BackorderSubscribeAction => ({
  type: BACKORDER_SUBSCRIBE,
  payload: {
    email,
    isSubscribed,
  },
});

const backorderSubscribeFulfilled = (email: string, isSubscribed: boolean): BackorderSubscribeFulfilledAction => ({
  type: BACKORDER_SUBSCRIBE_FULFILLED,
  payload: {
    email,
    isSubscribed,
  },
});

const backorderSubscribeRejected = (
  error: ErrorType,
): BackorderSubscribeRejectedAction => ({
  type: BACKORDER_SUBSCRIBE_REJECTED,
  payload: {
    error,
  },
});

export {
  backorderSubscribe,
  backorderSubscribeFulfilled,
  backorderSubscribeRejected,
  clearBackorderSubscribe,
};
